<script lang="ts">
  import { project, orgOperators } from "$lib/services/store";
  import type { Operator } from "@/src/types/components/operators/Operator";
  import { getOperatorBackgroundImage, getOperatorLogo } from "$lib/common/helpers/image";
  import Terms from "$lib/admin/components/blocks/helpers/Terms.svelte";
  import Icons from "$lib/main/components/Icons.svelte";

  export let props: any;

  let operators = $orgOperators as Operator[];

  $: {
    if (props.listItems === undefined) {
      props.listItems = [];
    }
  }
</script>

<div class="content-grid {props?.styling?.marginTop ?? ''} {props?.styling?.marginBottom ?? ''}">
  <div class="highlighted-container">
    {#each props.listItems as item, index (index)}
      {#if item.operatorId}
        {#each operators as operator (operator.id)}
          {#if operator.id === item.operatorId}
            <div class="card">
              <a
                href={`${$project.settings.url}/${$project.settings.redirectUrl}/${operator?.name_lower}`}
                data-name={operator?.name}
                data-type="title"
                data-alias={`${index + 1} Highlight`}
                data-element="top-banner"
                data-operator={operator?.name_lower}
                data-toplist-pos={index + 1}
                rel="nofollow noopener noreferrer"
                style="color: inherit;"
                target="_blank">
                <div
                    title={operator?.name}
                    class="background"
                    style={`background-color: rgba(${operator?.visuals?.[$project.key][$project.settings.market].primary_color});${!getOperatorBackgroundImage($project, operator?.background_image).includes('no_bg_image.png') ? ` background-image: url('${getOperatorBackgroundImage($project, operator?.background_image)}');` : ''}`}
                >
                  <img
                    class="logo"
                    data-name={operator?.name}
                    data-alias={`${index + 1} Highlight`}
                    data-element="top-banner"
                    data-operator={operator?.name_lower}
                    data-toplist-pos={index + 1}
                    src={getOperatorLogo($project, operator?.logo?.[$project.key])}
                    alt={operator?.name} />
                  <div class="overlay" style={`background-color: rgba(${operator?.visuals?.[$project.key][$project.settings.market].primary_color});`}></div>
                </div>
                <div
                  class="content"
                  style={`border-color: rgba(${operator?.visuals?.[$project.key][$project.settings.market].primary_color})`}>
                  <div class="text-container">
                    {#if item.title}
                      <div class="title">
                        {item.title}
                        <div style="position: absolute; right: 10px; top: 3px;">
                          <Icons strokeWidth="1" width="16" height="16" name="arrow-up-right" class="mr-1-2"></Icons>
                        </div>
                      </div>
                    {/if}
                    {#if item.content.length}
                      <span class="text">
                        {@html item.content}
                      </span>
                    {/if}
                  </div>
                  <div class="terms">
                    <Terms {operator} />
                  </div>
                </div>
              </a>
            </div>
          {/if}
        {/each}
      {/if}
    {/each}
  </div>
</div>

<style>
  .highlighted-container {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr;
  }

  @media (min-width: 992px) {
    .highlighted-container {
      grid-template-columns: repeat(4, 1fr);
    }

    .highlighted-container:has(> :first-child:nth-last-child(2)),
    .highlighted-container:has(> :first-child:nth-last-child(2) ~ *) {
      grid-template-columns: repeat(2, 1fr);
    }

    .highlighted-container:has(> :first-child:nth-last-child(3)),
    .highlighted-container:has(> :first-child:nth-last-child(3) ~ *) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .card {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: white;
    transition:
      transform 0.2s ease-in-out,
      box-shadow 0.2s ease-in-out;
    user-select: none;
    flex: 1;
    overflow: hidden;
    width: 100%;
  }
  .background {
    display: flex;
    height: 100px;
    padding: 10px;
    margin: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background-repeat: no-repeat;
    background-position: center;
    justify-content: center;
    align-items: center;
    background-size: cover;
    position: relative;
    overflow: hidden;
  }
  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.6;
    z-index: 0;
  }
  .logo {
    display: flex;
    max-width: 70%;
    max-height: 70px;
    width: auto;
    height: auto;
    min-height: 40px;
    min-width: 120px;
    object-fit: contain;
    z-index: 1;
  }
  .content {
    background-color: #f4f4f4;
    border: 1px solid red;
    border-top: none;
    border-radius: 0 0 8px 8px;
    padding: 10px;
  }

  @media (min-width: 992px) {
    .highlighted-container .text-container {
      height: 70px;
    }
    .content {
      height: 110px;
    }
  }

  :global(.highlighted-container .card .text-container .text p) {
    margin: 0;
  }
  .title {
    display: flex;
    position: relative;
    font-weight: 600;
    font-size: 16px;
    & > a {
      color: inherit;
    }
  }
  .text {
    display: block;
    font-size: 14px;
  }
  .terms {
    width: 100%;
    font-size: 10px;
    font-weight: 300;
    max-height: 16px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: #e0e0e0;
      border-radius: 6px;
      border: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background: #37505c;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #263942;
    }
  }
</style>
